import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from "@angular/core";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { ReportHTML } from "src/model/class/general classes/report-html";
import { ConnectionType } from "src/components/shared-components/enum/enumSettings";
import { iTranslation } from "src/components/shared-components/interfaces/iTranslation";
import { NetworkService } from "src/service/network.service";
import { serverSettings } from "src/state/selectors/server-settings-selector";

@Component({
    selector: "app-reporthtml",
    templateUrl: "./reporthtml.component.html",
    styleUrls: ["./reporthtml.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

/**
 *
 * Single entry report html component on app visualization
 *
 */
export class ReporthtmlComponent implements OnInit, OnDestroy, iTranslation {
  //#region Subcriptions to "_store.select(...)" Observables
  private _selectServerSettingsUserSub: Subscription = null;

  //#endregion

  private _translateSubscription: Subscription = null;

  public ShowReportHTML_Editing = true;
  public isOnline: boolean = false;

  //object report coming from report page
  @Input("Report") CurrentReportHTML: ReportHTML;
  @Output("editingReportHTML") editingReportHTML = new EventEmitter<number>();

  constructor(
    private _translateService: TranslateService,
    private _networkService: NetworkService,
    private _store: Store
  ) {
    //this.translationSub();
  }

  ngOnInit() {
    this.loadTranslation();
    this.subscribeTranslationEvent();

    this.subscribeNetowrkServiceData();

    /** GF: enable play/stop only if the user can use it */
    this._selectServerSettingsUserSub = this._store
      .select(serverSettings)
      .pipe(filter((setting) => setting !== null))
      .subscribe((settingsValue) => {
        this.ShowReportHTML_Editing = settingsValue.ShowReport;
      });
  }

  ngOnDestroy() {
    if (this._translateSubscription) {
      this._translateSubscription.unsubscribe();
    }
    this.unsubscribeStoreSelect();
  }

  //#region Translation
  public loadTranslation(): void { }

  public subscribeTranslationEvent() {
    this._translateSubscription = this._translateService.onLangChange.subscribe(
      () => {
        this.loadTranslation();
      }
    );
  }
  //#endregion

  /**
   *
   * @param event
   *
   * @param item current item sliding
   *
   *  event fired when item sliding button editing is clicked
   *
   */
  public onClick(event: any) {
    this.editingReportHTML.emit(this.CurrentReportHTML.id);
  }

  /**
   * Subscribe to network service observable data
   */
  private subscribeNetowrkServiceData(): void {
    this._networkService.currentConnectionType.subscribe(
      (currentConnectionType: ConnectionType) => {
        this.isOnline = currentConnectionType !== ConnectionType.NONE;
      }
    );
  }

  //#region Unsubscribe from "_store.selec(...)" Observable

  /**
   * This method handles the unsunìbscription from the Observables returned by the "_store.select(...)" invocations.
   * It SHOULD BE CALLED EACH TIME THE DATA STREAMS ARE NOT NEEDED ANYMORE; this means in:
   *
   * * OnDestroy() [Components/Services]
   * * OnViewWillLeave() [Pages]
   */
  private unsubscribeStoreSelect(): void {
    if (this._selectServerSettingsUserSub) {
      this._selectServerSettingsUserSub.unsubscribe();
    }
  }

  //#endregion
}
